const OutcomeLabelPosition = {
    title: 'Example JSON',
    expectedOutput: 'Feyenoord (betOffer description)',
    initialDisplayedCode: `{
    "outcomeId": 2950948554,
    "betOffer": {
      "id": 883929922,
      "betOfferType": {
        "id": 117,`,
    moreCode: `
    "name": "betOffer name"
  },
  "place": false,
    "outcomes": [
      {
        "id": 2950948551,
        "label": "Arsenal",
        "type": "OT_ONE_TWO"
      },
      {
        "id": 2950948554,
        "label": "Feyenoord",
        "type": "OT_ONE_CROSS"
      }
    ],
    "description": "betOffer description"
  },
  "event": {
    "awayName": "EventAwayName",
    "homeName": "EventHomeName"
  }
}`,
};

export default OutcomeLabelPosition;
